var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"draw-item"},[_c('div',[_c('canvas',{ref:"canvasRef",staticClass:"canvas-box",style:({
        width: _setup.rect.width,
        height: _setup.rect.height,
      }),attrs:{"width":_setup.rect.width,"height":_setup.rect.height,"id":`draw_item_img_canvas_${(_setup.props.arrIndex ?? 0) + 1}_${
        _setup.props.plankIndex
      }`}}),_c('div',[_c('span',{attrs:{"id":`draw_item_img_plankID_${(_setup.props.arrIndex ?? 0) + 1}_${
          _setup.props.plankIndex
        }`}},[_vm._v(_vm._s(_vm.plankInfo.plankID)+"#")]),_c('span',{attrs:{"id":`draw_item_img_partname_${(_setup.props.arrIndex ?? 0) + 1}_${
          _setup.props.plankIndex
        }`}},[_vm._v(_vm._s(_vm.plankInfo.partName))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }